<ng-container [ngSwitch]="locatorToolName">
  <div *ngSwitchCase="locatorToolNames.HealthCenter">
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <button (click)="aboutThisTool()" class="usa-button usa-button--unstyled text-no-underline link-button">
          About this tool
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <button
          (click)="noteToHrsaHealthCenters()"
          class="usa-button usa-button--unstyled text-no-underline link-button"
        >
          Note to HRSA Health Centers
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <a href="https://bphc.hrsa.gov/about-health-center-program" target="_blank"
          >About the Health Center program
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i
        ></a>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="locatorToolNames.HIVMedicalProvider">
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <button (click)="aboutThisToolHiv()" class="usa-button usa-button--unstyled text-no-underline link-button">
          About this tool
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12">
        <a class="navbar-routerLink" href="https://hab.hrsa.gov/about-ryan-white-hivaids-program" target="_blank"
          >About the Ryan White HIV/AIDS Program
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i
        ></a>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="locatorToolNames.OrganTransplantCenter">
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <button (click)="aboutThisToolOrgan()" class="usa-button usa-button--unstyled text-no-underline link-button">
          About this tool
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12">
        <button
          (click)="aboutOrganTransportCenters()"
          class="usa-button usa-button--unstyled text-no-underline link-button"
        >
          About Organ Transplant Centers
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="locatorToolNames.MigrantSeasonalHeadStart">
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <button (click)="aboutThisToolMigrants()" class="usa-button usa-button--unstyled text-no-underline link-button">
          About this tool
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon"></i>
        </button>
      </div>
    </div>
    <div class="grid-row">
      <div class="grid-col-12">
        <button
          (click)="aboutMigrantAndSeasonal()"
          class="usa-button usa-button--unstyled text-no-underline link-button"
        >
          About the Migrant and Seasonal Head Start Program
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
  </div>
  <div *ngSwitchCase="locatorToolNames.HealthCenterControlledNetwork">
    <div class="grid-row">
      <div class="grid-col-12 padding-bottom-2">
        <button (click)="aboutThisTool()" class="usa-button usa-button--unstyled text-no-underline link-button">
          About this tool
          <i class="fa-solid fa-arrow-up-right-from-square box-with-arrow-icon" aria-label="graphic Arrow up right"></i>
        </button>
      </div>
    </div>
  </div>
</ng-container>
